'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asRedirectRoute = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTES:
// - put more specific redirects first
// - use absolute paths to ensure no weird relative path behavior
var REDIRECTS = [{ from: '/radio', to: '/try/radio', preserveQuery: true }];

var asRedirectRoute = exports.asRedirectRoute = function asRedirectRoute(_ref) {
  var from = _ref.from,
      to = _ref.to,
      preserveQuery = _ref.preserveQuery;
  return {
    path: from,
    onEnter: function onEnter(nextState, replace) {
      return replace((0, _extends3.default)({
        pathname: to
      }, preserveQuery && { query: nextState.location.query }));
    }
  };
};

exports.default = REDIRECTS.map(asRedirectRoute);